/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_SelectInputs */

const cs_billing_plan_select = /** @type {(inputs: Billing_Plan_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte tarif…`)
};

const en_billing_plan_select = /** @type {(inputs: Billing_Plan_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a plan…`)
};

/**
* | output |
* | --- |
* | "Select a plan…" |
*
* @param {Billing_Plan_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_select = /** @type {((inputs?: Billing_Plan_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_select(inputs)
	return cs_billing_plan_select(inputs)
});